<template>
  <b-container>
    <h1>ERROR 404</h1>
  </b-container>
</template>
<script>
export default {
  name: 'ErrorPage',
  title() {
    return this.$gettext('Error 404')
  }
}
</script>
